// Runtime config loaded from /config.json so the deployed user can change
// the Web3Forms key, Google Sheet URL or business email WITHOUT rebuilding.

const DEFAULTS = {
  WEB3FORMS_ACCESS_KEY: 'bf2f9f2c-a6f1-4844-a43a-dc8005fb8f28',
  GOOGLE_SHEET_CSV_URL: '',
  BUSINESS_EMAIL: 'thenrirealtor@gmail.com',
  BUSINESS_PHONE: '919187108123',
};

let cached = null;
let inflight = null;

export const getConfig = async () => {
  if (cached) return cached;
  if (inflight) return inflight;

  const url = `${process.env.PUBLIC_URL || ''}/config.json`;
  inflight = fetch(url, { cache: 'no-store' })
    .then((r) => (r.ok ? r.json() : {}))
    .then((data) => {
      cached = { ...DEFAULTS, ...(data || {}) };
      return cached;
    })
    .catch(() => {
      cached = { ...DEFAULTS };
      return cached;
    });
  return inflight;
};
